import PropTypes from 'prop-types';
import React from 'react';
import { messageTypes } from '../../Includes/variables';
/* Components */
import StandaloneMessages from '../../Messages/StandaloneMessages/StandaloneMessages';
/* Stylesheets */
import './GroupChat.scss';

export default class GroupChat extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * string of chat's channel key
         */
        channelKey: PropTypes.string.isRequired,
        /**
         * object of header image
         */
        headerImage: PropTypes.shape({
            /**
             * string of src
             */
            src: PropTypes.string,
            /**
             * string of alt
             */
            alt: PropTypes.string,
        }).isRequired,
        /**
         * boolean to check if user is admin, superAdmin, moderator
         */
        isAdmin: PropTypes.bool.isRequired,
    };

    // for styling chat to be height of window
    // checks if there is a header image or not
    getClassName = () => {
        const { headerImage, isAdmin } = this.props;

        if (headerImage.src || isAdmin) {
            return 'with-header-image';
        }

        return '';
    };

    render() {
        const groupChatClassName = this.getClassName();

        return (
            <div className={`component-Groups-GroupChat ${groupChatClassName}`}>
                <StandaloneMessages
                    className="group-chat-room"
                    location="group-chat-page"
                    channelKey={this.props.channelKey}
                    messageType={messageTypes.GROUP}
                />
            </div>
        );
    }
}
